


















import Vue from 'vue';
import { mapGetters } from 'vuex';
import RegisterProgress from '../../components/register-progress.vue';
import BoxWrapper from '../../components/box-wrapper.vue';
import { makeMetaInfo } from '../../router/utils/meta';
import UserForm from './form.vue';
import * as RegistrationStore from '../../store/modules/register';
import * as ErrorStore from '../../store/modules/error';
import * as UiStore from '../../store/modules/ui';
import { i18n, i18nHints } from '@/plugins/i18n';
import PForm from '@/components/proff/PForm.vue';

export default Vue.extend({
  metaInfo: makeMetaInfo({ title: '保存' }),
  components: {
    BoxWrapper,
    RegisterProgress,
    UserForm,
  },
  data() {
    return {
      isAlertPageLeaving: true,
    };
  },
  computed: {
    ...mapGetters(RegistrationStore.namespace, ['userInfo', 'profileInfo']),
    ...mapGetters(ErrorStore.namespace, ['errors']),
    ...mapGetters(UiStore.namespace, ['isLoading']),
  },
  mounted() {
    if (!this.profileInfo || !this.profileInfo.email) {
      this.$router.replace({ name: 'cv_path' });
    }
    this.isAlertPageLeaving = true;
  },
  methods: {
    async onSubmit({
      password,
      password_confirmation,
    }: RegistrationStore.UserInfo) {
      try {
        await this.$store.dispatch(
          RegistrationStore.UpdateUserInfo.namespaced({
            password,
            password_confirmation,
          })
        );

        // NOTE: This could raise a 422 error with the message `メールアドレスは既に存在します`
        // when the email address has already registered.
        await this.$store.dispatch(
          RegistrationStore.CreateCvWithUser.namespaced(null)
        );

        // NOTE: Prevent from toasting a confirm while redirecting.
        const userForm = this.$refs.UserForm as InstanceType<typeof UserForm>;
        if (userForm) userForm.resetValidator();

        // Prevent showing beforeunload alert
        this.isAlertPageLeaving = false;
        this.$nextTick(() => {
          location.replace(
            `/?notice=${this.profileInfo.email}に登録確認メールを送信しました。`
          );
        });
      } catch (e) {
        this.$notifyError(
          i18n.tc(i18nHints.common.notification.check_input_validation_error)
        );
      }
    },
  },
});
